import { Button } from "../ui/button";
import { Badge } from "../ui/badge";

export const DHC_PORTFOLIO_NODES = [
  "@unisex_apparel_246",
  "@freshflowinc_246",
  "@renovations_bb",
  "@246_cheepsweepz",
  "CheepSweepz FB Page",
  "Digital Hustlers FB Page",
];

export default function DhcManagementPanel({
  broadcastTarget,
  setBroadcastTarget,
  broadcastMessage,
  setBroadcastMessage,
  submitBroadcast,
  savingBroadcast,
  broadcastStatus,
}) {
  return (
    <section className="rounded-3xl bg-white p-6 shadow-sm border border-slate-100">
      <div className="flex items-center justify-between gap-3 mb-4">
        <div>
          <h2 className="text-xl font-serif font-bold text-slate-900 mb-1">
            HQ Live Broadcast Injection
          </h2>
          <p className="text-sm text-slate-500">
            Drive ticker updates across the Mansion network from one command deck.
          </p>
        </div>
        <Badge className="bg-slate-100 text-slate-700 border-0">
          DHC HQ Control
        </Badge>
      </div>

      <div className="grid gap-4 md:grid-cols-[220px_1fr]">
        <select
          value={broadcastTarget}
          onChange={(event) => setBroadcastTarget(event.target.value)}
          className="rounded-2xl border border-slate-200 px-4 py-3 text-sm"
        >
          <option value="global">Global network</option>
          <option value="caribnavi.com">caribnavi.com</option>
          <option value="cheepsweepz.shop">cheepsweepz.shop</option>
          <option value="digitalhustlerscaribbean.com">digitalhustlerscaribbean.com</option>
        </select>
        <textarea
          value={broadcastMessage}
          onChange={(event) => setBroadcastMessage(event.target.value)}
          placeholder="Type the next Mansion network headline..."
          className="w-full min-h-[120px] rounded-[1.5rem] border border-slate-200 px-4 py-3 text-sm outline-none focus:ring-2 focus:ring-cyan-500"
        />
      </div>

      <div className="flex items-center justify-between gap-3 mt-4">
        <p className="text-sm text-slate-500">
          Posts to <code>/api/ticker/broadcast</code> and prepends the marquee stream instantly.
        </p>
        <Button
          type="button"
          onClick={submitBroadcast}
          disabled={savingBroadcast || !broadcastMessage.trim()}
          className="rounded-full"
        >
          {savingBroadcast ? "Publishing..." : "Publish Broadcast"}
        </Button>
      </div>

      {broadcastStatus && (
        <p className="mt-3 text-sm text-emerald-700">{broadcastStatus}</p>
      )}

      <div className="mt-6">
        <h3 className="text-sm font-semibold uppercase tracking-wide text-slate-500 mb-3">
          Portfolio Node Matrix
        </h3>
        <div className="flex flex-wrap gap-2">
          {DHC_PORTFOLIO_NODES.map((node) => (
            <Badge key={node} className="bg-cyan-50 text-cyan-700 border border-cyan-100">
              {node}
            </Badge>
          ))}
        </div>
      </div>
    </section>
  );
}
